module.exports = __webpack_public_path__ + "img/cp-mp-r1-1.09619d72.jpg";